// Small Web Audio helper for ring buzzer sounds. No external files needed.
let ctx;
function getCtx() {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function beep(ac, { freq, start, duration, gain, type = "square" }) {
  const t0 = ac.currentTime + start;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(gain, t0 + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + duration);
  osc.connect(g);
  g.connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + duration + 0.03);
}

// A struck metallic bell/gong via additive synthesis with inharmonic partials
// and a long exponential decay — the classic "end of the match" ring sound.
function bell(ac, { baseFreq, start, duration, gain }) {
  const t0 = ac.currentTime + start;
  const partials = [
    { ratio: 1.0, gain: 1.0 },
    { ratio: 1.5, gain: 0.55 },
    { ratio: 2.67, gain: 0.7 },
    { ratio: 4.07, gain: 0.4 },
    { ratio: 5.43, gain: 0.28 },
    { ratio: 8.2, gain: 0.16 },
  ];
  partials.forEach((p) => {
    const osc = ac.createOscillator();
    const g = ac.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(baseFreq * p.ratio, t0);
    const peak = gain * p.gain;
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(peak, t0 + 0.004);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + duration);
    osc.connect(g);
    g.connect(ac.destination);
    osc.start(t0);
    osc.stop(t0 + duration + 0.05);
  });
}

// End of a combat round: a resonant boxing bell — double strike with long ring.
export function playRoundEnd() {
  const ac = getCtx();
  if (!ac) return;
  bell(ac, { baseFreq: 523, start: 0, duration: 1.9, gain: 0.55 });
  bell(ac, { baseFreq: 523, start: 0.26, duration: 2.4, gain: 0.6 });
}

// End of the pause/break: softer single gentle beep.
export function playBreakEnd() {
  const ac = getCtx();
  if (!ac) return;
  beep(ac, { freq: 880, start: 0, duration: 0.28, gain: 0.3, type: "sine" });
}

// Warm up / unlock the audio context on a user gesture.
export function primeAudio() {
  getCtx();
}
